export enum FontAwesomeIconType {
  Solid = 'fa-solid',
  Regular = 'fa-regular',
  Light = 'fa-light',
  Thin = 'fa-thin',
  Duotone = 'fa-duotone'
}
